import PropTypes from "prop-types";
import React from "react";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { Brand } from "../../configurations";
import { SVGIcon2 } from "../../components/common/SVGIconV2";

const IslandResort = ({ handleClick }) => {
  const brandId = useSelector(UserContextSelectors.brandId);
  if (brandId !== Brand.Sport_MI) return <></>;
  else
    return (
      <div className="landResortIcon" onClick={handleClick}>
        <SVGIcon2 iconName="tribal-white" />
      </div>
    );
};

IslandResort.propTypes = {
  handleClick: PropTypes.func
};

export default IslandResort;
